module.exports = __webpack_public_path__ + "img/business_6.df48bacd.jpg";